import { render, staticRenderFns } from "./riskHgsj.vue?vue&type=template&id=472d77bc&scoped=true&"
import script from "./riskHgsj.vue?vue&type=script&lang=js&"
export * from "./riskHgsj.vue?vue&type=script&lang=js&"
import style0 from "./riskHgsj.vue?vue&type=style&index=0&id=472d77bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d77bc",
  null
  
)

export default component.exports